import React, { useEffect, useState } from "react";
import {
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import RoleAccessPage from "./RoleAccessPage";

const UserEditRights = ({
  userRolesDetails,
  UserRoleAccessService,
  setLoading,
  showNotification,
  AddRoleAccessService,
  loginUserInfo,
}) => {
  const [defaultValue, setDefaultValue] = useState(0);
  const [defaultFunctionValue, setDefaultFunctionValue] = useState(0);
  const [defaultUserTypeValue, setDefaultUserTypeValue] = useState(-1);
  const [userRoleMappingId, setUserRoleMappingId] = useState();
  const [userRoleAccessDetails, setUserRoleAccessDetails] = useState([]);
  const [checkDept, setCheckDept] = useState(false);
  const { register } = useForm();

  // useEffect(() => {
  //   setDefaultValue(userRolesDetails[0]?.deptId);
  //   setDefaultFunctionValue(
  //     userRolesDetails[0]?.functionUserTypeResponseList[0]?.functionId
  //   );
  //   setDefaultUserTypeValue(
  //     userRolesDetails[0]?.functionUserTypeResponseList[0]
  //       ?.userTypeMappingResponseList[0]?.userTypeId
  //   );
  //   setUserRoleMappingId(
  //     userRolesDetails[0]?.functionUserTypeResponseList[0]
  //       ?.userTypeMappingResponseList[0]?.userRoleMappingId
  //   );
  // }, [userRolesDetails]);

  // useEffect(() => {
  //   setDefaultFunctionValue(
  //     userRolesDetails.find((item) => item.deptId === defaultValue)
  //       ?.functionUserTypeResponseList[0].functionId
  //   );
  //   setDefaultUserTypeValue(
  //     userRolesDetails
  //       .find((item) => item.deptId === defaultValue)
  //       ?.functionUserTypeResponseList.find(
  //         (item) =>
  //           item.functionId ===
  //           userRolesDetails.find((item) => item.deptId === defaultValue)
  //             ?.functionUserTypeResponseList[0].functionId
  //       )?.userTypeMappingResponseList[0]?.userTypeId
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [defaultValue]);

  useEffect(() => {
    //console.log('userRolesDetails',userRolesDetails)
    setDefaultValue(
      userRolesDetails.find((d) => d.deptName === loginUserInfo.department)
        ?.deptId
    );
    setDefaultFunctionValue(
      userRolesDetails
        .find((d) => d.deptName === loginUserInfo.department)
        ?.functionUserTypeResponseList.find(
          (f) => f.funName === loginUserInfo.role
        )?.functionId
    );
    setDefaultUserTypeValue(
      userRolesDetails
        .find((d) => d.deptName === loginUserInfo.department)
        ?.functionUserTypeResponseList.find(
          (f) => f.funName === loginUserInfo.role
        )
        ?.userTypeMappingResponseList.find(
          (u) => u.userTypeName === loginUserInfo.userType
        )?.userTypeId
    );
    setUserRoleMappingId(
      userRolesDetails
        .find((d) => d.deptName === loginUserInfo.department)
        ?.functionUserTypeResponseList.find(
          (f) => f.funName === loginUserInfo.role
        )
        ?.userTypeMappingResponseList.find(
          (u) => u.userTypeName === loginUserInfo.userType
        )?.userRoleMappingId
    );
  }, [userRolesDetails]);

  useEffect(() => {
    if (checkDept === true) {
      setDefaultFunctionValue(
        userRolesDetails.find((item) => item.deptId === defaultValue)
          ?.functionUserTypeResponseList[0]?.functionId
      );
      setDefaultUserTypeValue(
        userRolesDetails
          .find((item) => item.deptId === defaultValue)
          ?.functionUserTypeResponseList.find(
            (item) =>
              item.functionId === 
              userRolesDetails.find((item) => item.deptId === defaultValue)
                ?.functionUserTypeResponseList[0].functionId
          )?.userTypeMappingResponseList[0]?.userTypeId     
      );
    } else {
      setDefaultFunctionValue(
        userRolesDetails
          .find((item) => item.deptId === defaultValue)
          ?.functionUserTypeResponseList.find(
            (f) => f.funName === loginUserInfo.role
          )?.functionId
      );
      setDefaultUserTypeValue(
        userRolesDetails
          .find((item) => item.deptId === defaultValue)
          ?.functionUserTypeResponseList.find(
            (item) =>
              item.functionId ===
              userRolesDetails
                .find((item) => item.deptId === defaultValue)
                ?.functionUserTypeResponseList.find(
                  (f) => f.funName === loginUserInfo.role
                )?.functionId
          )
          ?.userTypeMappingResponseList.find(
            (u) => u.userTypeName === loginUserInfo.userType
          )?.userTypeId
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  useEffect(() => {
    if (userRoleMappingId !== undefined) fetchUserRoleAccess(userRoleMappingId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoleMappingId]);

  const fetchUserRoleAccess = async () => {
    try {
      // setLoading(true);
      const response = await UserRoleAccessService(userRoleMappingId);
      if (response.statusCode === 6) {
        setUserRoleAccessDetails(response.data.accessPermissionResponseList);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    }
    //  finally {
    //   setLoading(false);
    // }
  };
  useEffect(() => {
    const getMappingId = userRolesDetails
      .find((item) => item.deptId === defaultValue)
      ?.functionUserTypeResponseList.find(
        (item) => item.functionId === parseInt(defaultFunctionValue)
      )
      ?.userTypeMappingResponseList.filter(
        (item) => item.userTypeId === parseInt(defaultUserTypeValue)
      )[0]?.userRoleMappingId;
    setUserRoleMappingId(getMappingId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, defaultFunctionValue, defaultUserTypeValue]);

  const onClickFunction = (e) => {
    setDefaultFunctionValue(e.target.value);
    setDefaultUserTypeValue(
      userRolesDetails
        .find((item) => item.deptId === defaultValue)
        ?.functionUserTypeResponseList.find(
          (item) => item.functionId === parseInt(e.target.value)
        )?.userTypeMappingResponseList[0]?.userTypeId
    );
    if (userRoleMappingId !== undefined) fetchUserRoleAccess(userRoleMappingId);
  };

  return (
    <>    
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={12} md={12} sx={{ mb: 2 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Edit Access Rights
            </Typography>
          </Grid>
          <Grid container xs={12} spacing={2} sx={{ px: 2 }} display="flex">
            <Grid item xs={3}>
              <Typography align="left" sx={{ mr: "auto" }}>
                Select your department
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography align="left">
                {/* Select your Department */}
                <FormControl>
                  <InputLabel id="demo-simple-select-label">
                    Department
                  </InputLabel>
                  <Select
                    className="stepperFormInput"
                    id="demo-simple-select"
                    label="Department"
                    name="deptId"
                    sx={{ width: 200 }}
                    value={defaultValue}
                    size="small"
                    autoComplete="off"
                    {...register("deptId", { required: true })}
                    onChange={(e) => {
                      setDefaultValue(e.target.value);
                      setCheckDept(true);
                    }}
                  >
                    {userRolesDetails &&
                      userRolesDetails.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.deptId}
                            sx={{ width: "100%" }}
                            value={d.deptId}
                            size="small"
                          >
                            {d.deptName}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Typography>
            </Grid>
          </Grid>
          <Grid container xs={12  } sx={{ mt: 2, px: 2 }} display="flex">
            <Grid item xs={3}>
              <Typography align="left" sx={{ mt: 1 }}>
                Functions
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography align="left">
                <FormControl>
                  <RadioGroup
                   classes={{root: 'custom-checkbox-root'}}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={defaultFunctionValue}
                    onChange={(e) => onClickFunction(e)}
                  >
                    {userRolesDetails &&
                      userRolesDetails
                        .find((item) => {
                          return item.deptId === defaultValue;
                        })
                        ?.functionUserTypeResponseList.map((item) => {
                          return (
                            <FormControlLabel
                              value={item.functionId}
                              control={<Radio />}
                              label={item.funName}
                            />
                          );
                        })}
                  </RadioGroup>
                </FormControl>
              </Typography>
            </Grid>
            <Grid container xs={12} sx={{ mt: 0 }}>
              <Grid item xs={3}>
                <Typography align="left" sx={{ mt: 1 }}>
                  User Type
                </Typography>
              </Grid>
              <Grid item xs={9} sx={{ textAlign: "left", mr: "auto" }}>
                <Typography align="left">
                  <FormControl>
                    <RadioGroup
                     classes={{root: 'custom-checkbox-root'}}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={defaultUserTypeValue}
                      onChange={(e) => {
                        setDefaultUserTypeValue(e.target.value);
                        if (userRoleMappingId !== undefined)
                          fetchUserRoleAccess(userRoleMappingId);
                      }}
                    >
                      {userRolesDetails &&
                        userRolesDetails
                          .find((item) => {
                            return item.deptId === defaultValue;
                          })
                          ?.functionUserTypeResponseList.find((item) => {
                            return (
                              item.functionId === parseInt(defaultFunctionValue)
                            );
                          })
                          ?.userTypeMappingResponseList.map((item) => {
                            return (
                              <FormControlLabel
                                value={item.userTypeId}
                                control={<Radio />}
                                label={item.userTypeName}
                              />
                            );
                          })}
                    </RadioGroup>
                  </FormControl>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mb={4} sx={{ px: 0 }}>
          <RoleAccessPage
            userRoleAccessDetails={userRoleAccessDetails}
            userRoleMappingId={userRoleMappingId}
            AddRoleAccessService={AddRoleAccessService}
            fetchUserRoleAccess={fetchUserRoleAccess}
            setLoading={setLoading}
            showNotification={showNotification}
            loginUserInfo={loginUserInfo}
          />
        </Grid>
      </Container>
    </>
  );
};

export default UserEditRights;
